module.exports = __webpack_public_path__ + "img/Smeet.03b21de5.png";